module.exports = __webpack_public_path__ + "img/ES0241.9f6a2331.png";